import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BE_URL,
  headers: {
    accept: "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers["X-TOKEN"] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response.status === 401 &&
      error.response.headers["x-token-refresh"]
    ) {
      const newToken = error.response.headers["x-token-refresh"];

      localStorage.setItem("access_token", newToken);
      originalRequest.headers["X-TOKEN"] = newToken;
      return api(originalRequest);
    }
    return Promise.reject(error);
  }
);

export default api;
